import { NewsModuleCard } from 'ui/components';

export const NewsModuleCardFeature: React.FC<Umbraco.NewsModuleCard> = ({ content, settings }) => (
	<NewsModuleCard {...content?.properties} settings={settings} />
);
